import {
  RecommendClassCautionsData,
  RecommendClassCautionsItem,
  RecommendClassCautionsTextPart,
} from '@/data/recommend-class/recommend-class.data';
import IconPlus from '@/svg/icon-plus.svg';

export interface CommonBottomCautionProps {
  className?: string;
  data: RecommendClassCautionsData;
  backgroundColor?: string;
  titleTextColor?: string;
  hrColor?: string;
  iconPlusColor?: string;
  iconRoundColor?: string;
  borderColor?: string;
}
export default function CommonBottomCaution({
  className,
  data,
  titleTextColor = '#333333',
  backgroundColor = '#F8F8F8',
  hrColor = '#D9D9D9',
  iconPlusColor = '#555555',
  iconRoundColor = '#CCCCCC',
  borderColor,
}: CommonBottomCautionProps) {
  return (
    <div
      className={`desktop:px-[40px] desktop:py-[32px] rounded-lg px-[24px] py-[28px] ${className || ''}`}
      style={{
        backgroundColor: backgroundColor,
        ...(borderColor && {
          border: '1px solid',
          borderColor: borderColor,
        }),
      }}
    >
      <div
        className="desktop:typo-20 typo-16 flex flex-wrap items-center gap-2 font-semibold"
        style={{
          color: titleTextColor,
        }}
      >
        <IconPlus
          className="h-5 w-5"
          style={
            {
              '--icon-plus-color': iconPlusColor,
              '--icon-circle-color': iconRoundColor,
            } as React.CSSProperties
          }
        />
        {data.title}
      </div>
      <hr
        className="desktop:my-[24px] my-[16px]"
        style={{ borderColor: hrColor }}
      />
      <div className="desktop:typo-18 typo-14 desktop:leading-relaxed leading-relaxed font-medium">
        {data.items.map((item: RecommendClassCautionsItem, index: number) => (
          <div key={index}>
            {item.parts.map(
              (part: RecommendClassCautionsTextPart, partIndex: number) => {
                if (part.bold) {
                  return (
                    <span
                      key={partIndex}
                      className="font-bold"
                      style={{
                        color: part.color || '#555555',
                      }}
                    >
                      {part.text}
                    </span>
                  );
                }
                return (
                  <span
                    key={partIndex}
                    style={{ color: part.color || '#555555' }}
                  >
                    {part.text}
                  </span>
                );
              },
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
